import { useMemo, useState } from "react";
import { toast } from "wc-toast";
import { useContextSelector } from "use-context-selector";
import {
  FaFacebookF,
  FaTelegramPlane,
  FaWhatsapp,
  FaWeixin,
  FaLine,
  FaCopy,
  FaShare,
  FaSave,
} from "react-icons/fa";
import AuthContext from "../../context/AuthContext";

const TABS = ["Overview", "Earnings", "Records", "Invited List"];
const WINNERS = [
  { user: "01********5", amount: "৳ 305.00" },
  { user: "ri******r", amount: "৳ 305.00" },
  { user: "sh****3", amount: "৳ 305.00" },
  { user: "mu******2", amount: "৳ 305.00" },
];

const SHARE = [
  ["Facebook", "#1877f2"],
  ["X", "#111"],
  ["Telegram", "#229ed9"],
  ["WhatsApp", "#25d366"],
  ["WeChat", "#09b83e"],
  ["Line", "#06c755"],
];

export default function Invite() {
  const [tab, setTab] = useState("Overview");
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const code =
    profileData?.referalCode || profileData?.referralCode || "chorki";
  const link = useMemo(() => {
    const base = process.env.REACT_APP_URL || `${window.location.origin}/`;
    return `${base.replace(/\/?$/, "/")}auth/register/?referral_code=${code}`;
  }, [code]);
  const qr = `https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${encodeURIComponent(link)}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success("Link Copied!");
    } catch {
      toast.error("Unable to copy link");
    }
  };

  return (
    <div id="mc_container" className="referral EN reference-invite">
      <div
        className="reference-invite-tabs"
        role="tablist"
        aria-label="Invite friends sections"
      >
        {TABS.map((name) => (
          <button
            key={name}
            type="button"
            role="tab"
            aria-selected={tab === name}
            className={tab === name ? "active" : undefined}
            onClick={() => setTab(name)}
          >
            {name}
          </button>
        ))}
      </div>

      {tab === "Overview" ? (
        <div className="reference-invite-overview">
          <div className="reference-invite-top">
            <div className="reference-invite-goals">
              <strong>Revenue goals</strong>
              <img
                src="/assets/images/friends-banner-icon.955ec94d.png"
                alt=""
                aria-hidden="true"
              />
              <p>Invite friends and earn rewards together.</p>
            </div>
            <div className="reference-invite-stats">
              <article>
                <span>Today&apos;s Income</span>
                <b>৳ 0.00</b>
              </article>
              <article>
                <span>Yesterday&apos;s Income</span>
                <b>৳ 0.00</b>
              </article>
              <article>
                <span>Registers</span>
                <b>0</b>
              </article>
              <article>
                <span>Valid Referral</span>
                <b>0</b>
              </article>
            </div>
          </div>

          <div className="reference-invite-mid">
            <section className="reference-invite-winners">
              <h3>Who received the rewards</h3>
              <ul>
                {WINNERS.slice(0, 3).map((row) => (
                  <li key={row.user}>
                    <span>{row.user}</span>
                    <em>Received</em>
                    <strong>{row.amount}</strong>
                  </li>
                ))}
              </ul>
            </section>
            <section className="reference-invite-share">
              <button type="button" className="reference-invite-commission">
                <span aria-hidden="true">❯</span> ONGOING AGENT COMMISSION
              </button>
              <div className="reference-invite-share-card">
                <h4>Share with your friends</h4>
                <div className="reference-invite-share-row">
                  <div className="reference-invite-qr">
                    <img
                      src={qr}
                      alt="Invite QR code"
                      width={120}
                      height={120}
                    />
                    <a className="new-invite" href={qr} target="_blank" rel="noopener noreferrer">
                      <FaSave /> Save invite code
                    </a>
                  </div>
                  <div className="reference-invite-link-box">
                    <input readOnly value={link} aria-label="Referral link" />
                    <button
                      type="button"
                      onClick={copyLink}
                      aria-label="Copy referral link"
                    >
                      <FaCopy />
                    </button>
                  </div>
                </div>
                <div className="reference-invite-social">
                  {SHARE.map(([name, color]) => (
                    <a
                      key={name}
                      href={
                        name === "Facebook"
                          ? `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`
                          : name === "X"
                            ? `https://twitter.com/intent/tweet?url=${encodeURIComponent(link)}`
                            : name === "Telegram"
                              ? `https://t.me/share/url?url=${encodeURIComponent(link)}`
                              : name === "WhatsApp"
                                ? `https://wa.me/?text=${encodeURIComponent(link)}`
                                : name === "Line"
                                  ? `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(link)}`
                                  : qr
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ background: color }}
                      aria-label={`Share on ${name}`}
                    >
                      {name === "Facebook" ? (
                        <FaFacebookF />
                      ) : name === "X" ? (
                        "𝕏"
                      ) : name === "Telegram" ? (
                        <FaTelegramPlane />
                      ) : name === "WhatsApp" ? (
                        <FaWhatsapp />
                      ) : name === "WeChat" ? (
                        <FaWeixin />
                      ) : (
                        <FaLine />
                      )}
                    </a>
                  ))}
                  <button
                    type="button"
                    aria-label="Share referral link"
                    onClick={copyLink}
                  >
                    <FaShare />
                  </button>
                </div>
              </div>
            </section>
          </div>

          <section className="reference-invite-released">
            <h3>Rewards Released to Date</h3>
            <div className="reference-invite-released-cards">
              {[
                [
                  "Invitation Rewards",
                  "/assets/images/invitation-reward.94bc2714.png",
                ],
                [
                  "Deposit Rebate",
                  "/assets/images/recharge-commission.cb8cf461.png",
                ],
                [
                  "Betting Rebate",
                  "/assets/images/betting-commission.cff1190c.png",
                ],
              ].map(([name, asset]) => (
                <article key={name}>
                  <img src={asset} alt="" />
                  <div>
                    <h4>{name}</h4>
                    <strong>৳ —</strong>
                    <p>— claimed</p>
                  </div>
                </article>
              ))}
            </div>
          </section>
        </div>
      ) : (
        <div className="reference-invite-empty">
          <h3>{tab}</h3>
          <p>No matched data</p>
        </div>
      )}
    </div>
  );
}
